import { useTranslation } from "react-i18next";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function SalaryExpectedIsLiquid({
  searchObject,
  setSearchObject
}) {
  const { t } = useTranslation();

  function clearExpectedSalaryNetGross() {
    let _searchObject = { ...searchObject };
    _searchObject.salaryExpectedValueIsLiquid = undefined;

    setSearchObject(_searchObject);
  }

  const onChangeExpectedSalaryType = (event) => {
    setSearchObject({
      ...searchObject,
      salaryExpectedValueIsLiquid:
        event.target.id === "salaryExpectedValueIsLiquid" ? true : false
    });
  };

  return (
    <div>
      <div className="form-check position-toogle-salary">
        <input
          className="form-check-input"
          type="radio"
          name="salaryExpectedValueIsLiquid"
          id="salaryExpectedValueIsLiquid"
          onChange={onChangeExpectedSalaryType}
          checked={searchObject.salaryExpectedValueIsLiquid}
        />
        <label htmlFor="salaryExpectedValueIsLiquid">{t("Liquid")}</label>
        <input
          className="form-check-input"
          type="radio"
          name="salaryExpectedValueIsLiquid"
          id="salaryExpectedValueIsNotLiquid"
          style={{ marginLeft: "30px" }}
          onChange={onChangeExpectedSalaryType}
          checked={searchObject.salaryExpectedValueIsLiquid === false}
        />
        <label htmlFor="salaryExpectedValueIsNotLiquid">{t("Gross")}</label>
      </div>
      {(searchObject.salaryExpectedValueIsLiquid === true ||
        searchObject.salaryExpectedValueIsLiquid === false) && (
        <button
          onClick={clearExpectedSalaryNetGross}
          className="btn-clear-salary-net-gross"
        >
          <img
            src={IconDelete}
            alt="ico-ppl"
            height="12px"
            width="auto"
            style={{ height: "14px" }}
          />
          <a className="clear-button">{t("Clear")}</a>
        </button>
      )}
    </div>
  );
}
